import { render, staticRenderFns } from "./GSiteHeader.vue?vue&type=template&id=48064af8&scoped=true&"
import script from "./GSiteHeader.vue?vue&type=script&lang=ts&"
export * from "./GSiteHeader.vue?vue&type=script&lang=ts&"
import style0 from "./GSiteHeader.vue?vue&type=style&index=0&id=48064af8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48064af8",
  null
  
)

export default component.exports